import './styles.css';

import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

import type {
  ReportSeverity,
  ReportSeverityDescriptions,
} from '@ipfabric/utils';

import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import { SeverityCounts } from 'components/SeverityCounts/SeverityCounts';

export interface SeverityCountsListItemProps {
  className?: string;
  name: ReactNode;
  onClick?: () => void;
  counts: Partial<Record<ReportSeverity, ReactNode>>;
  descriptions?: Partial<ReportSeverityDescriptions>;
  tooltip?: string;
}

export const SeverityCountsListItem: FC<SeverityCountsListItemProps> = (
  props,
) => (
  <div
    className={classNames(
      props.className,
      'severity-counts-list-item flex flex-1',
      props.onClick && 'severity-counts-list-item--clickable',
    )}
    onClick={props.onClick}
  >
    <div className='severity-counts-list-item__name flex-1'>
      <Tooltip content={props.tooltip}>
        <div>{props.name}</div>
      </Tooltip>
    </div>
    <SeverityCounts counts={props.counts} descriptions={props.descriptions} />
  </div>
);
